import { createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { isDevelopment, isBrowser } from 'utils/selector';
import middlewares from './middlewares';
import reducers from './reducers';
export const initStore = (initialState = {}) => createStore(reducers(), initialState, isDevelopment && isBrowser
    ? composeWithDevTools(middlewares)
    : middlewares);
export * from './types';
